import React from "react";
import { Container, Table, Col } from "react-bootstrap";

const fixed = {
  backgroundImage: `url('https://res.cloudinary.com/universitytix/image/upload/v1600942280/VC_h3fg11.png')`,
};

function Academics() {
  return (
    <div>
      <div id="resources" className="offset">
        <div className="fixed-background">
          <div className="row dark text-center ">
            <Col sm="12">
              <br />
              <br />
              <br />
              <br />
              <br />
              <h3 className="heading headers">
                Academic qualifications and certifications
              </h3>

              <br />
              <br />
              <br />
              <br />
              <div className="heading-underline"></div>
            </Col>
          </div>

          <div className="fixed-wrap">
            <div className="fixed" style={fixed}></div>
          </div>
        </div>
      </div>

      <Container>
        <br />
        <br />

        <h3 className="text-center">EDUCATIONAL BACKGROUND WITH DATES</h3>
        <br />
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>#</th>
              <th>Institutions Attended </th>
              <th>Dates</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>1</td>
              <td>St. James’ CAC Primary School, Iro, Akure</td>
              <td>1971 -1976</td>
            </tr>
            <tr>
              <td>2</td>
              <td>Ebun Ogunyinka College, Atosin Idanre</td>
              <td>1977-1982</td>
            </tr>
            <tr>
              <td>3</td>
              <td>University of Ibadan, Ibadan, Nigeria</td>
              <td>1983-1987</td>
            </tr>

            <tr>
              <td>4</td>
              <td>University of Ibadan, Ibadan, Nigeria</td>
              <td>1988-1990</td>
            </tr>

            <tr>
              <td>5</td>
              <td>University of Ibadan, Ibadan, Nigeria</td>
              <td>1990-1994</td>
            </tr>

            <tr>
              <td>6</td>
              <td>
                International Institute of Pastoral Education and Chaplaincy,
                Sango Ota, Ogun State
              </td>
              <td>2012-2013</td>
            </tr>
          </tbody>
        </Table>
        <br />
        <br />

        <h3 className="text-center">ACADEMIC QUALIFICATIONS WITH DATES</h3>
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>#</th>
              <th>Institutions Attended </th>
              <th>Dates</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>1</td>
              <td>B.Sc. (Hons.) (Ibadan) Second Class Upper Division</td>
              <td>1987</td>
            </tr>
            <tr>
              <td>2</td>
              <td>M.Sc. (Radiation & Health Physics) (Ibadan)</td>
              <td>1990</td>
            </tr>
            <tr>
              <td>3</td>
              <td>Ph.D. (Radiation & Health Physics) (Ibadan)</td>
              <td>1994</td>
            </tr>

            <tr>
              <td>4</td>
              <td>
                Post-Graduate Diploma in Pastoral Education & Chaplaincy
                (Sango-Ota)
              </td>
              <td>2013</td>
            </tr>
          </tbody>
        </Table>

        <br />
        <br />
        <h3 className="text-center">PROFESSIONAL TRAINING</h3>
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>#</th>
              <th>Institution</th>
              <th>Type of Training</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>1</td>
              <td>
                International Centre for Theoretical Physics, (ICTP), Trieste,
                Italy
              </td>
              <td>Radiation Protection & Imaging </td>
              <td>1992</td>
            </tr>

            <tr>
              <td>2</td>
              <td>
                International Centre for Theoretical Physics, (ICTP), Trieste,
                Italy
              </td>
              <td>Nuclear Power Plant Simulation</td>
              <td>2001</td>
            </tr>
            <tr>
              <td>3</td>
              <td>
                Kwame Nkrumah University of Science and Technology, Kumasi,
                Ghana
              </td>
              <td>Advanced VLSI Design Techniques</td>
              <td>2003</td>
            </tr>

            <tr>
              <td>4</td>
              <td>
                International Centre for Theoretical Physics, (ICTP), Trieste,
                Italy
              </td>
              <td>Nuclear Knowledge Management</td>
              <td>2007</td>
            </tr>

            <tr>
              <td>5</td>
              <td>
                International Centre for Theoretical Physics, (ICTP), Trieste,
                Italy
              </td>
              <td>Soil Physics </td>
              <td>2007</td>
            </tr>

            <tr>
              <td>6</td>
              <td>
                nternational Centre for Theoretical Physics, (ICTP), Trieste,
                Italy
              </td>
              <td>Gamma Spectroscopy Principles Uncertainty Measurements</td>
              <td>2007</td>
            </tr>
            <tr>
              <td>7</td>
              <td>
                International Centre for Theoretical Physics, (ICTP), Trieste,
                Italy
              </td>
              <td>Physics & Technology of Fast Reactors Systems</td>
              <td>2009</td>
            </tr>
            <tr>
              <td>8</td>
              <td>
                International Centre for Theoretical Physics, (ICTP), Trieste,
                Italy
              </td>
              <td>
                Irradiation-induced Embrittlement of Pressure Vessel Vessel
                Steels
              </td>
              <td>2009</td>
            </tr>
            <tr>
              <td>9</td>
              <td>Association of African Universities, Ghana</td>
              <td>Leadership Skill Development</td>
              <td>2010</td>
            </tr>
            <tr>
              <td>10</td>
              <td>
                Galilee International Management Institute, Galilee, Israel
              </td>
              <td>Management of Higher Education Institution </td>
              <td>2012</td>
            </tr>
            <tr>
              <td>11</td>
              <td>Harvard University Extension School (Israel)</td>
              <td>Recent Trends in Higher Education</td>
              <td>2012</td>
            </tr>

            <tr>
              <td>12</td>
              <td>Harvard University Extension School (Israel)</td>
              <td>Executive Speaker Training </td>
              <td>2012</td>
            </tr>
            <tr>
              <td>13</td>
              <td>
                Centre for Excellence for Software Engineering, Obafemi Awolowo
                University, (OAU), Ile-Ife
              </td>
              <td>ICT Application in Teaching Research and Administration</td>
              <td>2013</td>
            </tr>

            <tr>
              <td>14</td>
              <td>Executive Trainers, Johannesburg, South Africa</td>
              <td>
                International Top Executive Training on Managing the University
                Community: Exploring Good Practice
              </td>
              <td>2014</td>
            </tr>

            <tr>
              <td>15</td>
              <td>Digital Bridge Institute, Abuja.</td>
              <td>
                Advanced Digital Appreciation Programme for Tertiary
                Institutions, ADAPTI
              </td>
              <td>2017</td>
            </tr>
          </tbody>
        </Table>
        <br />
        <br />

        <h3 className="text-center">ACADEMIC DISTINCTION</h3>
        <br />
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>#</th>
              <th>Institution</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>1</td>
              <td>
                Best Mathematics Student, Ebun Ogunyinka College, Atosin-Idanre.
              </td>
              <td>1981</td>
            </tr>

            <tr>
              <td>2</td>
              <td>
                Winner, Federal Government Postgraduate Scholarship, University
                of Ibadan
              </td>
              <td>1992</td>
            </tr>
            <tr>
              <td>3</td>
              <td>
                Regular Associate, International Centre for Theoretical Physics
                (ICTP), Trieste, Italy.
              </td>
              <td>2006 to date</td>
            </tr>
            <tr>
              <td>4</td>
              <td>
                Visiting Research Associate, University of Bremen, Germany
              </td>
              <td>2005 to 2007</td>
            </tr>

            <tr>
              <td>5</td>
              <td>Fellow, Nigerian Institute of Physics.</td>
              <td>2016</td>
            </tr>

            <tr>
              <td>6</td>
              <td>
                International Institute of Pastoral Education and Chaplaincy,
                Sango Ota, Ogun State
              </td>
              <td>2012-2013</td>
            </tr>
          </tbody>
        </Table>
        <br />
        <br />
      </Container>
    </div>
  );
}

export default Academics;
